import { createTelemetryAPI } from '~/utils/telemetry'

export const orgClustersTelemetry = createTelemetryAPI(({ track }) => ({
  searchCluster(name: string) {
    return track('Org Clusters: Search Cluster', { name })
  },
  clickPagination({ page, pageSize }: { page: number; pageSize: number }) {
    return track('Org Clusters: Click Pagination', { page, pageSize })
  },
  clickClusterItem({ name, id }: { name: string; id: string }) {
    return track('Org Clusters: Click Cluster Item', { name, id })
  },
  clickUpload() {
    return track('Org Clusters: Click Upload Menu Button')
  },
  clickUploadItem(item_name: string) {
    return track('Org Clusters: Click Upload Menu Item', { item_name })
  },
  genAccessToken() {
    return track('Org Clusters: Generate Access Token')
  },
  copyAccessToken() {
    return track('Org Clusters: Copy Access Token')
  },
  confirmDelAccessToken() {
    return track('Org Clusters: Confirm Delete Access Token')
  }
}))
